import { useState } from 'react';
import { cn } from '../../lib/cn';

export function Tooltip({ children, content, side = 'top', className, delayMs = 150 }) {
  const [open, setOpen] = useState(false);
  const [timer, setTimer] = useState(null);

  if (!content) return children;

  function show() {
    if (timer) clearTimeout(timer);
    setTimer(setTimeout(() => setOpen(true), delayMs));
  }
  function hide() {
    if (timer) clearTimeout(timer);
    setOpen(false);
  }

  const positions = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2',
  };

  return (
    <span
      className="relative inline-flex"
      onMouseEnter={show}
      onMouseLeave={hide}
      onFocus={show}
      onBlur={hide}
    >
      {children}
      {open && (
        <span
          role="tooltip"
          className={cn(
            'pointer-events-none absolute z-[80] whitespace-nowrap rounded-lg px-2.5 py-1.5 text-[11px] font-medium',
            positions[side],
            className
          )}
          style={{
            background: 'var(--dash-text)',
            color: 'var(--dash-bg)',
            boxShadow: '0 8px 24px rgba(0,0,0,0.35)',
            animation: 'tooltip-fade 0.15s ease-out',
          }}
        >
          {content}
          <style>{`
            @keyframes tooltip-fade {
              from { opacity: 0; transform: translate(var(--tw-translate-x, -50%), 4px); }
              to { opacity: 1; transform: translate(var(--tw-translate-x, -50%), 0); }
            }
          `}</style>
        </span>
      )}
    </span>
  );
}
